<div class="zwi-section-headline" [class]="{'zwi-section-headline--offset': offset}">
  <ng-content></ng-content>
</div>
